import { Record } from 'immutable';

import { GENERIC_ERROR } from 'constants/errors.constants';
import {
  ADD_DAMAGE_FAIL,
  ADD_DAMAGE_PICTURE_FAIL,
  ADD_DAMAGE_PICTURE_SUCCESS,
  ADD_DAMAGE_SUCCESS,
  CLEAR_ERRORS,
  CLEAR_TRIP,
  DELETE_TRIP_FAIL,
  DELETE_TRIP_SUCCESS,
  GET_TRIP_FAIL,
  GET_TRIP_SUCCESS,
  QUERY_TRIPS_FAIL,
  QUERY_TRIPS_SUCCESS,
  REMOVE_DAMAGE_FAIL,
  REMOVE_DAMAGE_PICTURE_FAIL,
  REMOVE_DAMAGE_PICTURE_SUCCESS,
  REMOVE_DAMAGE_SUCCESS,
  START_LOADING,
  UPDATE_DAMAGE_FAIL,
  UPDATE_DAMAGE_SUCCESS,
} from './actions';

const TripsStateRecordFactory = Record({
  errors: Record({})(),
  loading: false,
  trip: null,
  trips: {
    count: 0,
    offset: 0,
    next: '',
    previous: '',
    results: [],
  },
});

export const TripRecordFactory = Record({
  id: '',
  dealership: null,
  type: null,
  roId: '',
  agreement: null,
  scheduledDate: '',
  start: '',
  end: '',
  damages: [],
  driver: null,
  completedDate: '',
  customerSource: null,
  customerDmsId: '',
  customerFirstName: '',
  customerLastName: '',
  customerEmail: '',
  customerAddress1: '',
  customerAddress2: '',
  customerPostalCode: '',
  customerCity: '',
  customerState: '',
  customerCountry: '',
  customerBusinessName: '',
  customerPhoneCell: '',
  customerLanguage: '',
  customerNotificationPreference: '',
  customerNote: '',
  customerSignature: null, // TODO: signature type
  originAddress1: '',
  originAddress2: '',
  originPostalCode: '',
  originCity: '',
  originState: '',
  originCountry: '',
  destinationAddress1: '',
  destinationAddress2: '',
  destinationPostalCode: '',
  destinationCity: '',
  destinationState: '',
  destinationCountry: '',
  distance: null,
  notes: '',
  vehicleSource: null,
  vehicleVin: '',
  vehicleLicensePlate: '',
  vehicleMake: '',
  vehicleModel: '',
  vehicleYear: null,
  vehicleExteriorColor: '',
  vehicleInspectionNotes: '',
});

export const initialState = TripsStateRecordFactory();

const tripsServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return state.merge({ loading: true, errors: initialState.errors });
    case CLEAR_ERRORS:
      return state.merge({
        errors: initialState.errors,
      });
    case QUERY_TRIPS_SUCCESS:
      return state.merge({
        loading: false,
        trips: {
          ...action.payload.data,
          results: action.payload.data.results.map((result) => TripRecordFactory(result)),
          offset: action.payload.offset,
        },
        errors: initialState.errors,
      });
    case QUERY_TRIPS_FAIL:
      return state.merge({
        loading: false,
        trips: initialState.trips,
        errors: action.payload.errors || GENERIC_ERROR,
      });
    case GET_TRIP_SUCCESS:
      return state.merge({
        loading: false,
        trip: TripRecordFactory(action.payload.data),
        errors: initialState.errors,
      });
    case GET_TRIP_FAIL:
      return state.merge({
        loading: false,
        trip: state.trip || initialState.trip,
        errors: action.payload.errors || GENERIC_ERROR,
      });
    case DELETE_TRIP_SUCCESS:
      return state.merge({
        loading: false,
        trip: initialState.trip,
        errors: initialState.errors,
      });
    case DELETE_TRIP_FAIL:
      return state.merge({
        loading: false,
        trip: state.trip || initialState.trip,
        errors: action.payload.errors || GENERIC_ERROR,
      });
    case CLEAR_TRIP:
      return state.merge({
        trip: initialState.trip,
      });
    case ADD_DAMAGE_FAIL:
    case ADD_DAMAGE_PICTURE_FAIL:
    case REMOVE_DAMAGE_FAIL:
    case REMOVE_DAMAGE_PICTURE_FAIL:
    case UPDATE_DAMAGE_FAIL:
      return state.merge({
        loading: false,
        errors: action.payload.errors || GENERIC_ERROR,
      });
    case ADD_DAMAGE_PICTURE_SUCCESS: {
      const damageIndex = state.trip?.damages.findIndex((damage) => damage.id === action.payload.damageId);

      return damageIndex !== undefined
        ? state
            .merge({
              loading: false,
              errors: initialState.errors,
            })
            .updateIn(['trip', 'damages', damageIndex, 'pictures'], (damagesPictures) =>
              // @ts-expect-error TS(2339): Property 'concat' does not exist on type 'unknown'... Remove this comment to see the full error message
              damagesPictures.concat(action.payload.pictures)
            )
        : state;
    }
    case ADD_DAMAGE_SUCCESS:
      return (
        state
          .merge({
            loading: false,
            errors: initialState.errors,
          })
          // @ts-expect-error TS(2339): Property 'concat' does not exist on type 'unknown'... Remove this comment to see the full error message
          .updateIn(['trip', 'damages'], (vehiclesDamages) => vehiclesDamages.concat(action.payload.damage))
      );
    case REMOVE_DAMAGE_SUCCESS: {
      const damageIndex = state.trip?.damages.findIndex((damage) => damage.id === action.payload.damageId);
      return damageIndex !== undefined
        ? state
            .merge({
              loading: false,
              errors: initialState.errors,
            })
            .deleteIn(['trip', 'damages', damageIndex])
        : state;
    }
    case REMOVE_DAMAGE_PICTURE_SUCCESS: {
      const damages = state.trip?.damages;
      const damageIndex = damages?.findIndex((damage) => damage.id === action.payload.damageId);
      const pictureIndex =
        damageIndex !== undefined
          ? damages?.[damageIndex].pictures.findIndex((picture) => picture.id === action.payload.pictureId)
          : undefined;

      return damageIndex !== undefined && pictureIndex !== undefined
        ? state
            .merge({
              loading: false,
              errors: initialState.errors,
            })
            .removeIn(['trip', 'damages', damageIndex, 'pictures', pictureIndex])
        : state;
    }
    case UPDATE_DAMAGE_SUCCESS: {
      const damageIndex = state.trip?.damages.findIndex((damage) => damage.id === action.payload.damageId);

      return damageIndex !== undefined
        ? state
            .merge({
              loading: false,
              errors: initialState.errors,
            })
            .setIn(['vehicle', 'damages', damageIndex], action.payload.damage)
        : state;
    }
    default:
      return state;
  }
};

export default tripsServiceReducer;
